// extracted by css-extract-rspack-plugin
export default {"codeEditor":"KJCbR"};